import { FC } from 'react';
import { ArrowUpRightIcon } from '@phosphor-icons/react';
import styles from './FollowUps.module.scss';

interface FollowUpsProps {
  questions: string[];
  onAsk: (q: string) => void;
}

/**
 * Chip "Continua" con domande di follow-up. Adattato dal mockup AI Coach.
 */
export const FollowUps: FC<FollowUpsProps> = ({ questions, onAsk }) => {
  if (!questions || questions.length === 0) return null;
  return (
    <div className={styles.wrapper}>
      <div className={styles.label}>Continua</div>
      <div className={styles.chips}>
        {questions.map((q) => (
          <button key={q} type="button" className={styles.chip} onClick={() => onAsk(q)}>
            {q} <ArrowUpRightIcon size={11} weight="bold" />
          </button>
        ))}
      </div>
    </div>
  );
};
